export var StateTypes;

(function (StateTypes) {
  StateTypes["NONE"] = "NONE";
  StateTypes["UI_REQUESTED"] = "UI_REQUESTED";
  StateTypes["UI_DISPLAYED"] = "UI_DISPLAYED";
})(StateTypes || (StateTypes = {}));

export var ErrorTypes;

(function (ErrorTypes) {
  ErrorTypes["INVALID_STATE"] = "INVALID_STATE";
})(ErrorTypes || (ErrorTypes = {}));
//# sourceMappingURL=enums.js.map